import React, {useCallback, useLayoutEffect} from "react";
import styled from "styled-components";

import {useHistory} from "react-router-dom";
import {Spinner} from "@chakra-ui/react";
import useAtBottom from "../utils/use_at_bottom";
import {themecolors} from "../utils/themecolors";
import {useStoreProfile} from "../store";
import ScrollToTop from "./scroll_to_top";
import {Item} from "./post_list";
import Virtualize from "./virtualize";
import RefreshFeed from "./refresh_feed";
import Comment2 from "./comment2";

const SpinnerContainer = styled.div`
  text-align: center;
  padding: 48px 0;
`;

const ContentList = styled(({className, noBorders, content, polled, loading, refresh, loadNextPage, expand, onOpenPost, feedKey, queueContext, profile, signalRef}) => {

    const {theme} = useStoreProfile();
    const scrollToTop = useCallback(() => {
        document.scrollingElement.scrollTop = 0;
    }, []);
    useLayoutEffect(scrollToTop, [feedKey]);
    if (signalRef.current === 'scrollToTop') {
        signalRef.current = null;
        scrollToTop();
    }
    const detector = useAtBottom(!loading && loadNextPage);

    const history = useHistory();
    const handleSubthread = (comment) => {
        if (profile) {
            history.push(`/p/${comment.post_uuid}/x/c/${comment.uuid}/`);
        }
    };

    return (<>
        {content.length === 0 && loading &&
        <SpinnerContainer>
            <Spinner
                thickness='4px'
                speed='0.65s'
                emptyColor={theme === "dark" ? themecolors.dark_background_5 : themecolors.light_low_impact_text}
                color={theme === "dark" ? themecolors.dark_background_2 : themecolors.pure_white}
                size='lg'
            />
        </SpinnerContainer>
        }
        <Virtualize
            key={feedKey}
            className={className}
            items={content}
            keyOfItem={(item, index) => item?.uuid || index}
            renderItem={(item, index) => (
                'comments' in item ? (
                    <Item
                        item={item}
                        expand={expand}
                        onOpenPost={onOpenPost}
                        first={index === 0}
                        queueContext={queueContext}
                        noBorders={noBorders}
                    />
                ) : (
                    <div onClick={() => handleSubthread(item)}>
                        <Comment2
                            key={item.id}
                            comment={item}
                            contextual
                        />
                    </div>
                )
            )}
        />
        {!loading && detector}
        <ScrollToTop onClick={scrollToTop}/>
        {polled && <RefreshFeed onClick={refresh} count={polled.ids.length}/>}
    </>);
})`
  height: 100%;
  margin-bottom: 56px;
  ${Comment2}, ${Item} {
    border-bottom: 1px solid ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_4 : themecolors.lighter_border};
  }
`;

export default ContentList;
